
// -------------- PRODUCT Page --------------
export const PRODUCT_FIELD_ERROR       = 'PRODUCT_FIELD_ERROR';
export const PRODUCT_FIELD_RESET_ERROR = 'PRODUCT_FIELD_RESET_ERROR';
export const PRODUCT_GET_ITEM          = 'PRODUCT_GET_ITEM';
export const PRODUCT_SET_ITEM          = 'PRODUCT_SET_ITEM';
export const PRODUCT_SET_ALL           = 'PRODUCT_SET_ALL';
export const PRODUCT_ADD_ITEM          = 'PRODUCT_ADD_ITEM';

export const CATEGORY_FIELD_ERROR       = 'CATEGORY_FIELD_ERROR';
export const CATEGORY_FIELD_RESET_ERROR = 'CATEGORY_FIELD_RESET_ERROR';
export const CATEGORY_SET_ITEM          = 'CATEGORY_SET_ITEM';
export const CATEGORY_SET_ALL           = 'CATEGORY_SET_ALL';
export const CATEGORY_GET_ITEM          = 'CATEGORY_GET_ITEM';
export const CATEGORY_ADD_ITEM          = 'CATEGORY_ADD_ITEM';



// --------- PRODUCT Page ---------
export function productFieldError(field, fieldData = {}) {
    return { type: PRODUCT_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}

export function productFieldResetError(field, fieldData = {}) {
    return { type: PRODUCT_FIELD_RESET_ERROR }
}
export function productGetItem(targetItem) {
    return { type: PRODUCT_GET_ITEM, data: targetItem }
}
export function productSetItem(targetItem) {
    return { type: PRODUCT_SET_ITEM, data: targetItem }
}
export function productAddItem(addItem) {
    return { type: PRODUCT_ADD_ITEM, data: addItem }
}
export function productSetList(allPRODUCT) {
    return { type: PRODUCT_SET_ALL, data: allPRODUCT }
}

// --------- CATEGORY Page ---------
export function categoryFieldError(field, fieldData = {}) {
    return { type: CATEGORY_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}

export function categoryFieldResetError(field, fieldData = {}) {
    return { type: CATEGORY_FIELD_RESET_ERROR }
}
export function categorySetItem(targetItem) {
    return { type: CATEGORY_SET_ITEM, data: targetItem }
}
export function categoryAddItem(addItem) {
    return { type: CATEGORY_ADD_ITEM, data: addItem }
}
export function categorySetList(allCATEGORY) {
    return { type: CATEGORY_SET_ALL, data: allCATEGORY }
}
export function categoryGetItem(targetItem) {
    return { type: CATEGORY_GET_ITEM, data: targetItem }
}
